var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"field",staticClass:"vue-form__input",attrs:{"type":_vm.type,"placeholder":"Type your answer here..."},domProps:{"value":_vm.value},on:{"input":e => _vm.$emit('input', e.target.value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }